import React from "react";
import ErhWorkspace from "./ErhWorkspace";
export default function AdvisorErhWorkspace() { return <ErhWorkspace role="doctor" />; }
